import { create } from 'zustand'

export const useFilter = create((set) => ({
  customer_id: '',
  user_id: '',
  updateCustId: (customer_id: any) => set(() => ({ customer_id: customer_id })),
  updateUserId: (user_id: any) => set(() => ({ user_id: user_id })),
}))
